import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, roleHome } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy" data-testid="route-loading">
        <Loader2 className="h-8 w-8 animate-spin text-cyanx" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (localStorage.getItem("rc_must_change") === "1" && location.pathname !== "/cambia-password") {
    return <Navigate to="/cambia-password" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={roleHome(user.role)} replace />;
  }
  return children;
}
